import React, { useState } from 'react'
import ChevronIcon from 'svg/expand-icon.svg'

import classNames from 'classnames'

type Props = {
  data: Record<string, any>
}

const Component = ({ data }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { name, title, blurb, image } = data
  const [toggle, handleToggle] = useState(false)
  return (
    <div
      data-type='team-member'
      {...(toggle
        ? {
            [`data-toggle`]: true,
          }
        : {})}
    >
      <div data-type='content'>
        <div data-type='image'>
          <img
            className=' lazyload'
            loading='lazy'
            width='180'
            height='180'
            data-src={image}
            alt={`Saatchi For The Trade - ${name}`}
            itemProp='image'
          />
        </div>
        <div data-type='bio'>
          <div data-section='team-member-content'>
            <h6
              className={classNames('defaultTypographyH6', 'defaultTextCenter')}
              data-type='team-member-name'
            >
              {name}
            </h6>
            <p
              className={classNames('defaultTypographySmall', 'defaultTextCenter')}
              data-type='team-member-title'
            >
              {title}
            </p>
            <ChevronIcon data-type='icon' />
            <p
              className={classNames('defaultTypographySmall', 'defaultTextCenter')}
              data-type='blurb'
            >
              {blurb}
            </p>
          </div>

          {/* Mobile Hit Spot for toggle hidden content */}
          <button type='button' data-type='toggle' onClick={() => handleToggle(!toggle)} />
        </div>
      </div>
    </div>
  )
}

export default Component
